const INIT_STATE = {
  none: "none",
};
export default (state = INIT_STATE, action) => {
  return state;
};
